<template>
  <v-container>
    <v-card class="overflow-hidden">
      <v-card-text>
        <ValidationObserver ref="dialog">
          <v-row>
            <v-col cols="3">
              <ValidationProvider :name="$t('settle_type')" rules="required" v-slot="{ errors }">
                <v-autocomplete
                  :items="allSettleType"
                  item-text="Name"
                  item-value="Type"
                  :loading-text="$t('common_get_data')"
                  :no-data-text="$t('common_no_results')"
                  v-model="setSale.SettleType"
                  :error-messages="errors[0]"
                  @change="setDay"
                  @keyup.enter="setSettleTypeAutocomplete"
                  ref="settleTypeAutocomplete"
                  :disabled="isLoadingSaveBtn"
                >
                  <template v-slot:label>
                    <span class="red--text">
                      <strong>* </strong>
                    </span>
                    {{ $t('settle_type') }}
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col cols="3">
              <ValidationProvider
                :name="$t('settle_sale_type')"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  :items="computedSaleType"
                  item-text="Name"
                  item-value="Type"
                  :loading-text="$t('common_get_data')"
                  :no-data-text="$t('common_no_results')"
                  v-model="setSale.SaleType"
                  :error-messages="errors[0]"
                  @keyup.enter="setSaleTypeAutocomplete"
                  ref="saleTypeAutocomplete"
                  :disabled="isLoadingSaveBtn"
                >
                  <template v-slot:label>
                    <span class="red--text">
                      <strong>* </strong>
                    </span>
                    {{ $t('settle_sale_type') }}
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3"> </v-col>
            <v-col cols="3">
              <ValidationProvider name="年份" rules="required" v-slot="{ errors }">
                <v-autocomplete
                  :items="allYear"
                  :loading-text="$t('common_get_data')"
                  :no-data-text="$t('common_no_results')"
                  v-model="setSale.Year"
                  :error-messages="errors[0]"
                  @keyup.enter="setYearAutocomplete"
                  ref="yearAutocomplete"
                  :disabled="isLoadingSaveBtn"
                >
                  <template v-slot:label>
                    <span class="red--text">
                      <strong>* </strong>
                    </span>
                    年份
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3"> </v-col>
            <v-col cols="3">
              <ValidationProvider name="月份" rules="required" v-slot="{ errors }">
                <v-autocomplete
                  :items="monthList"
                  :loading-text="$t('common_get_data')"
                  :no-data-text="$t('common_no_results')"
                  v-model="setSale.Month"
                  :error-messages="errors[0]"
                  @keyup.enter="setMonthAutocomplete"
                  ref="monthAutocomplete"
                  :disabled="isLoadingSaveBtn"
                >
                  <template v-slot:label>
                    <span class="red--text">
                      <strong>* </strong>
                    </span>
                    月份
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3"> </v-col>
            <v-col cols="3">
              <ValidationProvider
                :name="$t('month_sale_item_settle_day')"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  :items="allDay"
                  :disabled="setSale.SettleType === 3 || isLoadingSaveBtn"
                  :loading-text="$t('common_get_data')"
                  :no-data-text="$t('common_no_results')"
                  v-model="setSale.Day"
                  :error-messages="errors[0]"
                  @keyup.enter="setDayAutocomplete"
                  ref="dayAutocomplete"
                >
                  <template v-slot:label>
                    <span class="red--text">
                      <strong>* </strong>
                    </span>
                    {{ $t('month_sale_item_settle_day') }}
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row v-if="setSale.SettleType !== 1">
            <v-col cols="3"></v-col>
            <v-col cols="3">
              <ValidationProvider
                :name="$t('settle_customer')"
                rules="required"
                v-slot="{ errors }"
                v-if="setSale.SettleType !== 1"
              >
                <v-autocomplete
                  v-model="setSale.CustomerLicensePlateList"
                  :items="allMonth"
                  item-text="LicensePlate"
                  item-value="LicensePlate"
                  small-chips
                  multiple
                  return-object
                  :loading-text="$t('common_get_data')"
                  :no-data-text="$t('common_no_results')"
                  :error-messages="errors[0]"
                  @keydown.enter="setKeyDownAutocomplete"
                  @keyup.enter="setKeyUpAutocomplete"
                  @click="getCustomerLicensePlateList"
                  ref="licensePlateAutocomplete"
                  :disabled="isLoadingSaveBtn"
                >
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content @click="test = !test">
                        <v-list-item-title>{{ data.item.LicensePlate }} </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ data.item.CustomerNumber }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle
                          >{{ $t('quotation_shortname') }} :
                          {{ data.item.CustomerName }}</v-list-item-subtitle
                        >
                        <v-list-item-subtitle
                          >{{ $t('quotation_full_name') }} :
                          {{ data.item.CustomerFullName }}</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </template>
                  </template>
                  <template v-slot:label>
                    <span class="red--text">
                      <strong>* </strong>
                    </span>
                    {{ $t('settle_customer') }}
                  </template>
                  <!-- <template v-slot:selection="{ item }">
                    {{ setSelectText(item) }}
                  </template> -->
                </v-autocomplete>
              </ValidationProvider>
            </v-col>
          </v-row>
        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="isLoadingSaveBtn" @click="setSaleBtn">
          {{ $t('settle_set_sale') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { HttpSettle, HttpMonth, HttpDiscount, HttpOverage, HttpMonthQuotation } from '@/js/http-Manager' // HttpCmsmq,
export default {
  name: 'Settle',

  data: () => ({
    allSettleType: [],
    allSaleType: [],
    allMonth: [],
    setSale: {
      Month: new Date().getMonth() + 1,
      Year: new Date().getFullYear(),
      SettleType: 1,
      SaleType: '40',
      Day: null,
      CustomerLicensePlateList: []
    },
    test: false,
    tempLicensePlateList: [],
    isLoadingSaveBtn: false
  }),
  async mounted () {
    await this.getSettleType()
    // await this.getSaleType()
  },
  methods: {
    // setSelectText (item) {
    //   console.log(item)
    //   return (
    //     item.CustomerNumber + ' - ' + item.CustomerName.substring(0, 4) + ' - ' + item.LicensePlate
    //   )
    // },
    setSettleTypeAutocomplete (event) {
      this.$refs.settleTypeAutocomplete.isMenuActive = false
      this.$refs.settleTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setSaleTypeAutocomplete (event) {
      this.$refs.saleTypeAutocomplete.isMenuActive = false
      this.$refs.saleTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setYearAutocomplete (event) {
      this.$refs.yearAutocomplete.isMenuActive = false
      this.$refs.yearAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setMonthAutocomplete (event) {
      this.$refs.monthAutocomplete.isMenuActive = false
      this.$refs.monthAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setDayAutocomplete (event) {
      this.$refs.dayAutocomplete.isMenuActive = false
      this.$refs.dayAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setKeyDownAutocomplete () {
      ///  儲存keydown之前的Roles
      this.tempLicensePlateList = this.setSale.CustomerLicensePlateList
    },
    setKeyUpAutocomplete (event) {
      this.$refs.licensePlateAutocomplete.isMenuActive = false
      this.$refs.licensePlateAutocomplete.isFocused = false
      ///  塞回keydown之前的Roles  給KeyUp的Model editedUser.Roles
      this.setSale.CustomerLicensePlateList = this.tempLicensePlateList
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    setItemText (item) {
      return (
        item.CustomerNumber + ' - ' + item.CustomerName.substring(0, 4) + ' - ' + item.LicensePlate
      )
    },
    async getSettleType () {
      let response = await HttpSettle.GetSettleType()
      this.allSettleType = response.status === 200 ? response.data.Data : []
    },
    // async getSaleType () {
    //   let response = await HttpCmsmq.GetSaleType()
    //   this.allSaleType = response.status === 200 ? response.data.Data : []
    // },
    setDay () {
      this.setSale.Day = null
      if (this.setSale.SettleType === 3) {
        this.setSale.Day = new Date().getDate()
      }
    },
    async setSaleBtn () {
      const isValid = await this.$refs.dialog.validate()
      if (isValid) {
        this.isLoadingSaveBtn = true
        let response
        let isError = false
        let array = []
        if (this.setSale.SaleType === '2354') {
          response = await HttpSettle.GetOverageError(this.setSale)
          if (response && response.status === 200) {
            array = response.data.Data
            isError = array.length > 0
          } else {
            isError = true
          }
        }
        if (!isError) {
          await HttpDiscount.UpdateDiscountWithSettle(this.setSale)
          await HttpOverage.UpdateOverageWithSettle(this.setSale)
          await HttpSettle.SetSaleDetail(this.setSale)
          await HttpMonthQuotation.ProcessUnlimitedMonthQuotationList(this.setSale)
        } else {
          alert(array)
        }

        this.isLoadingSaveBtn = false
      }
    },
    async getCustomerLicensePlateList () {
      let response = await HttpMonth.GetAllCustomerLicensePlateList()
      this.allMonth = response.status === 200 ? response.data.Data : []
    }
  },
  computed: {
    monthList () {
      let array = []
      for (let index = 0; index < 12; index++) {
        array.push(index + 1)
      }
      return array
    },
    allYear () {
      let array = []
      let nowYear = new Date().getFullYear() - 1
      for (let index = nowYear; index <= nowYear + 2; index++) {
        array.push(index)
      }
      return array
    },
    allDay () {
      let array = []
      if (this.setSale.SettleType === 1) {
        array.push(20, 25, 30)
      } else {
        for (let index = 1; index < 32; index++) {
          array.push(index)
        }
      }
      return array
    },
    computedSaleType () {
      return [{ Name: '審核銷貨', Type: '40' }]
    }
  }
}
</script>
